import $ from 'jquery';

$('.the-logo-carousel').slick({
  infinite: true,
  arrows: true,
  dots: false,
  slidesToShow: 5,
  slidesToScroll: 1,
  autoplay: true,
  responsive: [{
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }

  ]
});

$('.the-testimonial-carousel').slick({
  infinite: true,
  arrows: false,
  dots: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 12000,
  fade: true
});

$('.blue-section-carousel').slick({
  infinite: true,
  arrows: false,
  dots: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 6000,
  mobileFirst: true,
  responsive: [
    {
      breakpoint: 768,
      settings: 'unslick'
    }
  ]
});

$('.live-reporting-carousel').slick({
  infinite: true,
  arrows: false,
  dots: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 6000,
  mobileFirst: true,
  responsive: [
    {
      breakpoint: 768,
      settings: 'unslick'
    }
  ]
});